
export default class Currency {
   amount = 0
   text = ''
   id = 0
}
